import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";

export type LevelSelectorProps = {
  mapZoom: number;
  selectedLevels?: number[];
  selectedZoomLevel?: number | null;
  onChange?: (selectedLevels: number[], toggledLevel: number, checked: boolean) => void;
  onToggle?: (level: number, checked: boolean) => void;
  getZoomColor: (zoom: number) => string;
};

const LevelSelector = ({
  mapZoom,
  selectedLevels,
  selectedZoomLevel,
  onChange,
  onToggle,
  getZoomColor
}: LevelSelectorProps) => (
  <Box
    sx={{
      border: "1px solid",
      borderColor: "divider",
      bgcolor: "background.paper",
      borderRadius: 1,
      px: 0.5,
      py: 0.75
    }}
  >
    <FormGroup
      row
      sx={{
        mt: 0.5,
        flexWrap: "nowrap",
        justifyContent: "space-between",
        width: "100%",
        px: 0
      }}
    >
      {Array.from({ length: 16 }, (_, index) => {
        const levelColor = getZoomColor(index);
        const disabled = index <= mapZoom;
        const computedSelected = selectedLevels ?? (selectedZoomLevel != null ? [selectedZoomLevel] : []);
        const checked = computedSelected.includes(index);
        return (
          <FormControlLabel
            key={index}
            control={
              <Checkbox
                size="small"
                checked={checked}
                onChange={(_event, isChecked) => {
                  const nextLevels = isChecked
                    ? [...computedSelected, index]
                    : computedSelected.filter((level) => level !== index);
                  const uniqueSorted = Array.from(new Set(nextLevels)).sort((a, b) => a - b);
                  if (onChange) {
                    onChange(uniqueSorted, index, isChecked);
                  }
                  if (onToggle) {
                    onToggle(index, isChecked);
                  }
                }}
                sx={{
                  p: 0.15,
                  color: levelColor,
                  "&.Mui-checked": {
                    color: levelColor
                  },
                  "&.Mui-disabled": {
                    color: levelColor,
                    opacity: 0.45
                  },
                  "& .MuiSvgIcon-root": {
                    fontSize: "1rem"
                  }
                }}
                disabled={disabled}
              />
            }
            label={`${index}`}
            labelPlacement="bottom"
            sx={{
              m: 0,
              alignItems: "center",
              "& .MuiFormControlLabel-label": {
                fontSize: "0.75rem",
                lineHeight: 1,
                mt: 0.15,
                color: levelColor
              }
            }}
            disabled={disabled}
          />
        );
      })}
    </FormGroup>
  </Box>
);

export default LevelSelector;
